import { Component, Inject, OnInit, EventEmitter } from '@angular/core';
import { HandlerModal } from '../../handler-modals';
import { DAyudasFormularioNoExperto } from '../../../../../../configuracion/dayudas-formulario-no-experto';
import { MAT_DIALOG_DATA,MatDialogRef } from '@angular/material';
import { DDocumento } from '@dian/api-formulario';
import { DirectionType } from '../../handler-modals';
import { DOperacionesMatematicasServicio, DTipoOperacionAritmetica } from '@dian-cmp/formulario';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { SugeridaSingletonService } from '../../../../../../services/sugerida.service';

const VAL_INDICADOR_COMPLETO="999";//Valor de referencia, si el indicador esta en este valor entonces ya paso todos los steps y el modal esta completo
const ID_CAS_INDICADOR_AVANCE='cs_id_141';

const stepsList = [
    { text: "1", active: true, completed: false, tooltip: '', listHelp: ['161'] }
  ];
  
  const tableStructure = [
      {id: 'desc', title: 'Descripción'}, 
      {id: 'origen', title: 'Origen información'}, 
      {id: 'valActivo', title: 'Valor a declarar'},
  ];
  
  
  class Form1 {
    id: number;
    desc: string;
    valActivo:string;
    origen:string;
  }
  
  class ArticulosDominio {
    valor: number;
    nombre: string;
  }

@Component({
  selector: 'app-patrimonio-otros-activos-modal',
  templateUrl: './patrimonio-otros-activos-modal.component.html',
  styleUrls: ['./patrimonio-otros-activos-modal.component.css'],
  providers: [
    DNotificacionServicio,
    DOperacionesMatematicasServicio
  ]
})
export class PatrimonioOtrosActivosModalComponent extends HandlerModal implements OnInit {

  saveModel = new EventEmitter();
  showSave:boolean; 
  dataSourceHeader = tableStructure;
  dataSourceBody = [];
  modelForm: Form1 = new Form1();
  OPERACION_NULA:number = 0;
  OPERACION_AGREGAR:number = 1;
  OPERACION_EDITAR:number = 2;
  OPERACION_BORRAR:number = 3; 
  operacionTabla:number = this.OPERACION_NULA;
  model:DDocumento;
  mensajeTabla = "Algunos campos fueron sugeridos por el sistema(basados en su información exógena). Edite, agregue o elimine ítems de ser necesario.";
  mensajeForm = "Este ítem fue sugerido con base a su información exógena. Al editarlo no esta editando su exógena, simplemente no será usada para este ítem.";
  constructor(
    public dutilidades:DOperacionesMatematicasServicio, 
    public dNotificacionServicio: DNotificacionServicio,
    public dialogRef: MatDialogRef<PatrimonioOtrosActivosModalComponent>,
    private _sugeridaSingletonService: SugeridaSingletonService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { 
    super(stepsList, DAyudasFormularioNoExperto.AYUDAS_FORMULARIO);
    this.model = this.data.model;
    console.log("otrosActivos:"+this.model);
  }

  ngOnInit() {
    this.inicializeModelo();
    this.inicializeForm();
    this.initializeTablaDesdeModelo();
    this.initializeTablaDesdeSugerida();
    this.validateBtnRightActive();
    this.validateShowSave();
  }
  
  protected inicializeModelo(){
    if(this.model.doc.cuerpo.cc_id_228 == undefined){

      this.model.doc.cuerpo.cc_id_228 = []; //descripcion
      this.model.doc.cuerpo.cc_id_229 = []; //origen
      this.model.doc.cuerpo.cc_id_230 = []; //valor
      this.model.doc.cuerpo.cs_id_162 = "0";
   
    }  
  }

  
  protected inicializeForm(){
    this.modelForm = new Form1();
    this.modelForm.id=0;
    this.modelForm.desc="";
    this.modelForm.valActivo="";
    this.modelForm.origen="";
  }
  


  public operaciones(numCas?:number,soloEstaCasilla?:boolean):void {
    switch (numCas) {
      case 169:
        this.operacionCs162();
        break;
    }
    if(soloEstaCasilla)return;

    //Operaciones
    let resultado = "0";

  }

  public operacionCs162(){ 
    let suma = "0";
    for(let i=0; i<this.dataSourceBody.length; i++){
        suma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,this.dataSourceBody[i].valActivo, suma);
    }
    this.model.doc.cuerpo.cs_id_162 = suma;
  }

  protected initializeTablaDesdeModelo(){
    this.dataSourceBody = [];
    for(let i=0; i<this.model.doc.cuerpo.cc_id_228.length; i++){
      this.modelForm.id=i;
      this.modelForm.desc=this.model.doc.cuerpo.cc_id_228[i].v;
      this.modelForm.origen=this.model.doc.cuerpo.cc_id_229[i].v;
      this.modelForm.valActivo=this.model.doc.cuerpo.cc_id_230[i].v;

      this.dataSourceBody.push(this.modelForm);
      this.inicializeForm();
    }
  }

  protected initializeTablaDesdeSugerida(){
    let indexModel = this.model.doc.cuerpo.cc_id_228.length;
    if(indexModel==0){
      const fieldsRecovery = ['VAR_1993','VAR_1994','VAR_2158','VAR_2159','VAR_2160','VAR_2161','VAR_2163','VAR_2164','VAR_2166','VAR_2381','VAR_4420','VAR_4421','VAR_4422','VAR_5118','VAR_5119','VAR_5122','VAR_5123','VAR_2256_4'];
      const resData = this._sugeridaSingletonService.getDataArrFromMap(fieldsRecovery);
      console.log(resData);
      if(resData)
      {
        for(let i=0; i<resData.length; i++){
          for(let j=0; j<resData[i].item.value.length; j++){
          //const existeValor = this.model.doc.cuerpo.cc_id_228.some(item => item.v === this.data.sugerida[i].desc);

          //if(!existeValor){
            
            this.modelForm.id=indexModel;
            this.modelForm.desc=resData[i].item.numNitInformante[j]+"/"+resData[i].item.nomRazonSocialInformante[j];
            this.modelForm.valActivo=String(resData[i].item.value[j]);
            this.modelForm.origen="0";
            this.redondearFormData();
            this.dataSourceBody.push(this.modelForm);
            this.inicializeForm();
            indexModel++;
          //}
        }
          
        }
      }
    console.log(this.data.sugerida)
    }

    this.operacionCs162();
  }

  public validateFormCompleted():boolean{
    return this.modelForm.desc==undefined || this.modelForm.desc==null || this.modelForm.desc.trim()=="" ||
        this.modelForm.valActivo==undefined || /* this.modelForm.valCompra=="0" || */ 
        this.modelForm.origen==undefined || this.modelForm.origen==null 
  }

  public redondearFormData(){
    this.modelForm.valActivo=this.dutilidades.redondearValorMoneda(this.modelForm.valActivo.toString(),true);
  }

  public editModeloDesdeForm(){
   
    this.model.doc.cuerpo.cc_id_228[this.modelForm.id].v=this.modelForm.desc;
    this.model.doc.cuerpo.cc_id_229[this.modelForm.id].v=this.modelForm.origen.toString();
    this.model.doc.cuerpo.cc_id_230[this.modelForm.id].v=this.modelForm.valActivo.toString();

  }

  public addToModeloDesdeForm(){
    let i= this.modelForm.id+1;
    this.model.doc.cuerpo.cc_id_228.push({it: i, v:this.modelForm.desc});
    this.model.doc.cuerpo.cc_id_229.push({it: i, v:this.modelForm.origen});
    this.model.doc.cuerpo.cc_id_230.push({it: i, v:this.modelForm.valActivo.toString()});
    

  }

  public deleteOnModel(index:number){
    this.model.doc.cuerpo.cc_id_228.splice(index,1);
    this.model.doc.cuerpo.cc_id_229.splice(index,1);
    this.model.doc.cuerpo.cc_id_230.splice(index,1);

    //reenumerear it
    for(let i=0;i<this.model.doc.cuerpo.cc_id_228.length;i++){
      this.model.doc.cuerpo.cc_id_228[i].it=i+1;
      this.model.doc.cuerpo.cc_id_229[i].it=i+1;
      this.model.doc.cuerpo.cc_id_230[i].it=i+1;
    }
  }

  saveItem(): void {
    if(this.validateFormCompleted()){
      let dialogError = this.dNotificacionServicio.mostrarDialogoError("Debe diligenciar todos los campos para agregar un nuevo registro" );
      return;
    }else{
      this.redondearFormData();
      if (this.operacionTabla==this.OPERACION_EDITAR){
        //const existeValor = this.model.doc.cuerpo.cc_id_228.some(item => item.v === this.modelForm.desc);
      
       /*  if(this.modelForm.origen=="2" || this.modelForm.origen=="1" || (existeValor && this.modelForm.origen=="0")){ //editando contribuyente o editando sugerida
          this.modelForm.origen = this.modelForm.origen=="0" && this.modelForm.origen=="0" ? "1" : this.modelForm.origen;
          this.editModeloDesdeForm();
        }else if(this.modelForm.origen=="0"){ //editando sugerida
          this.modelForm.origen = "1";
          this.modelForm.id = this.model.doc.cuerpo.cc_id_228.length;
          this.addToModeloDesdeForm();
        } */

          if(this.modelForm.origen=="0"){ 
            this.modelForm.origen = "1";
          }
          this.dataSourceBody.forEach((el)=>{
            if(el.id == this.modelForm.id){
              el=this.modelForm;
            }
          });
     
      }else if (this.operacionTabla==this.OPERACION_AGREGAR){ //agregando nuevo por el contribuyente
        this.modelForm.id = this.model.doc.cuerpo.cc_id_228.length;
        this.modelForm.origen = "2";
        this.dataSourceBody.push(this.modelForm);
        //this.addToModeloDesdeForm();
      }
      //Recalcular y reinicializar
      this.operacionCs162();
      this.inicializeForm();
      this.operacionTabla=this.OPERACION_NULA;
    }
  }

  eventTable($event: string): void {
    if($event === 'add') this.operacionTabla=this.OPERACION_AGREGAR;
    if($event === 'edit') this.operacionTabla=this.OPERACION_EDITAR;
    if($event === 'delete') this.operacionTabla=this.OPERACION_BORRAR;
    this.operacionCs162();
  }

  updateItemSelected($event: any): void {
    let index = $event;
    if(this.operacionTabla==this.OPERACION_EDITAR){//editando
      this.modelForm = this.dataSourceBody[index];
    }
    if(this.operacionTabla==this.OPERACION_BORRAR){//borrando
      //this.deleteOnModel(index);
      this.operacionTabla=this.OPERACION_NULA;
    }
  }
  
  cancel(): void {
    this.inicializeForm();
    this.operacionTabla=this.OPERACION_NULA;
  }
  ///////////////////////

  //Aplica si dentro del modal hay preguntas SI/NO que bloquean el avance
  public validateRbQuestions(val: string) {

  }
  
  //Aplica para revisar si hay preguntas que se habilitaron con una previa respuesta SI en el modal
  protected validateHasModalValues(indexQuestion:number): boolean{
    let hasValues:boolean = false;
    return hasValues;
  }

  //Aplica normalmente si se cambia el valor SI a NO en una pregunta del modal y deben eliminarse valores los valores previamente diligenciados
  protected cleanModalValues(indexQuestionModal:number){
    
  }
  
  //Aplica si dentro del modal existen condiciones que deshabilite el avance (como preguntas SI/NO)
  public validateStepHabilitado(indexS:number):boolean{
    let habilitado = true;
    return habilitado;
  }

  //Aplica si dentro del modal existen condiciones que deshabilite el avance (como preguntas SI/NO)
  public validateBtnRightActive(){

  }

  //////////////////////////
  
  protected obtenerCasIndicadorAvance():string{
    if(this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]==undefined){
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]="0";
    }
    return this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE];
  }
  protected updateIndicadorAvance(){
    let casIndicadorAvance=this.obtenerCasIndicadorAvance();
    if(this.indexStepper> Number(casIndicadorAvance)){
      let indexS = this.indexStepper+1;
      while(!this.validateStepHabilitado(indexS)){
        indexS++;
      }
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]=indexS.toString();
    }
    if(this.indexStepper==this.stepsList.length-1){
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]=VAL_INDICADOR_COMPLETO;
    }
  }

  protected controlStep(direction: DirectionType): void {
   
  }

 
  
  protected validateShowSave(){
    if(this.indexStepper==this.stepsList.length-1 || this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]==VAL_INDICADOR_COMPLETO){ this.showSave=true };
  }

  public closeModal(){
    this.initializeTablaDesdeModelo();
    this.operacionCs162();
    this.dialogRef.close("");
  }
  public guardar(){
    /* if(this.model.doc.cuerpo.cc_id_228.length != this.dataSourceBody.length){ 
      for(let i=0; i<this.dataSourceBody.length; i++){
        const existeValor = this.model.doc.cuerpo.cc_id_228.some(item => item.v === this.dataSourceBody[i].desc);
         if(!existeValor && this.dataSourceBody[i].origen=="0"){
          this.modelForm = this.dataSourceBody[i];
          this.addToModeloDesdeForm(); 

         }
      }
    }   */

    this.model.doc.cuerpo.cc_id_228 = undefined;
    this.inicializeModelo();
    for(let i=0; i<this.dataSourceBody.length; i++){
      this.modelForm = this.dataSourceBody[i];
      this.addToModeloDesdeForm();
    }

    this.operacionCs162();
    this.saveModel.emit(true); 
    this.closeModal();
  }

  public borrarTabla(){
    this.dataSourceBody = [];
  }

  protected cleanInput(nameInput: string): void {
    if(this.modelForm[nameInput] == "0" || this.modelForm[nameInput] == "")
      this.modelForm[nameInput] = '';
  }

}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/secciones/modales/patrimonio/patrimonio-otros-activos-modal/patrimonio-otros-activos-modal.component.ts